import { useMutation } from '@tanstack/react-query'

import type { FileRef } from '@/lib/api/common'

import { uploadFile } from '../api'

/**
 * One upload at a time, which is what every image field in the Back Office needs.
 *
 * Not a query: an upload is not cacheable and re-running it would store the file
 * twice.
 */
export function useFileUpload() {
  const upload = useMutation<FileRef, Error, File>({ mutationFn: uploadFile })

  return {
    upload: (file: File) => upload.mutateAsync(file),
    isUploading: upload.isPending,
    error: upload.error,
  }
}
